import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SocketService } from './socket.service';
// import oboe from 'oboe';
import { EnhanceDeviceService } from './enhance-device.service';
import { TrackerService } from './tracker.service';
import { environment } from 'src/environments/environment';
import { first, map, tap, Observable, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class DeviceService {
    private isActiveSubject = new BehaviorSubject<boolean>(false);
    isScreenRotated$ = this.isActiveSubject.asObservable();
    private baseUrl: any = environment.baseUrl;
    private baseUrlAiops: any = environment.baseUrlAiops;

    constructor(
        private http: HttpClient,
        public socketService: SocketService,
        public enhanceDeviceService: EnhanceDeviceService,
        private router: Router
    ) { }

    setActive(value: boolean): void {
        this.isActiveSubject.next(value);
    }

    trackAll(): TrackerService {



        const tracker = new TrackerService(
            { filter: () => true, digest: false },
            this.socketService,
            this.enhanceDeviceService,
            this
        );

        // oboe()(this.commonService.getBaseUrl() + '/api/v1/devices').node('devices[*]', function (device: any) {
        //   tracker.add(device);
        // });
        let session = JSON.parse(sessionStorage.getItem('session'));

        this.http.get(`${this.baseUrl}` + '/api/v1/devices').subscribe((response: any) => {



            response.devices.sort((a, b) => {
                if (a.present && a.using) return -1;
                if (b.present && b.using) return 1;
                if (a.present && !a.using) return -1;
                if (b.present && !b.using) return 1;
                return 0;
            });

            response.devices.forEach((device: any) => {
                tracker.add(device);
            });
        }, (error: any) => {
            if (error.status === 401) {
                //   this.logout(); // Call your logout logic
                localStorage.removeItem('currentUser')
                sessionStorage.removeItem('currentUser');
                localStorage.setItem('logoutEvent', Date.now().toString());
                // this.loginService.setcurrentUserSubject(null);
                this.router.navigate(['/login']);
                location.reload();
            }
        });

        return tracker;
    }

    trackGroup(): TrackerService {
        const tracker = new TrackerService(
            { filter: () => true, digest: false },
            this.socketService,
            this.enhanceDeviceService,
            this
        );

        // oboe()(`${this.baseUrl}` + `/api/v1/user/devices`).node('devices[*]', function (device: any) {
        //     tracker.add(device);
        // });

        this.http.get(`${this.baseUrl}` + `/api/v1/user/devices`).subscribe((response: any) => {
            response.devices.forEach((device: any) => {
                tracker.add(device);
            });
        })

        return tracker;
    }

    // load(serial: string) {
    //     return this.http.get(`${this.baseUrl}` + '/api/v1/devices/' + serial);
    // }

    // get(serial: string) {
    //     const tracker = new TrackerService(
    //         {
    //             filter: () => true,
    //             digest: false
    //         },
    //         this
    //     );

    //     this.load(serial).pipe(first()).subscribe((response: any) => {
    //         tracker.add(response.device);
    //         return response.device;
    //     });
    // }

    load(serial: string) {
        return this.http.get(`${this.baseUrl}/api/v1/devices/${serial}`);
    }

    get(serial: string) {
        const tracker = new TrackerService(
            { filter: () => true, digest: false },
            this.socketService,
            this.enhanceDeviceService,
            this
        );

        return this.load(serial).pipe(
            first(),
            tap((response: any) => {
                tracker.add(response.device);
            }),
            map((response: any) => response.device)
        );
    }

    getDevices(): Observable<any[]> {
        return this.http.get<any>(`${this.baseUrl}/api/v1/user/devices`).pipe(
            map((response: any) => {
                if (response && response.devices) {
                    // Return the devices array directly
                    return response.devices || [];
                }
                return [];
            })
        );
    }

    // Get a single connected device (first available)
    getCurrentDevice(): Observable<any> {
        return this.getDevices().pipe(
            map(devices => {
                if (devices && devices.length > 0) {
                    // Return the first connected device
                    return devices.find(device => device.present === true) || devices[0];
                }
                return null;
            })
        );
    }


    updateNote(serial: string, note: string): void {
        this.socketService.socket.emit('device.note', {
            serial: serial,
            note: note
        });
    }

    updateOwnerInfo(serial: string, user: string) {
        // let user2: String
        // user2=user.group

        return this.http.get(`${this.baseUrl}` + '/api/v1/devices/updateOwnerInfo?user=' + user + '&serial=' + serial);
    }

    putDisconnectionTimestamp(serial: string, disconnectionTimestampReason: string) {
        console.log("disconnectionTimestampReason :", disconnectionTimestampReason);
        let data = {
            disconnectionTimestampReason: disconnectionTimestampReason
        }
        return this.http.post(`${this.baseUrlAiops}` + `/putDisconnectionTimestamp`, data);
    }

    checkDeviceStatus(serial: string) {
        return this.http.get(`${this.baseUrl}` + `/api/v1/devices/${serial}/checkDeviceStatus`);
    }
}

// export class Tracker extends EventEmitter<any> {

//     devices: any[] = [];
//     devicesBySerial = Object.create(null);
//     scopedSocket: any;
//     digestTimer: any;
//     lastDigest: any;
//     enhanceDeviceService: EnhanceDeviceService;

//     constructor(
//         private $scope: any,
//         private options: any,
//         private deviceService: DeviceService
//     ) {
//         super();
//         this.scopedSocket = this.deviceService.socketService.scoped();
//         this.enhanceDeviceService = this.deviceService.enhanceDeviceService;

//         this.scopedSocket.on('device.add', this.addListener.bind(this));
//         this.scopedSocket.on('device.remove', this.changeListener.bind(this));
//         this.scopedSocket.on('device.change', this.changeListener.bind(this));
//         this.scopedSocket.on('device.addGroupDevices', this.addGroupDevicesListener.bind(this));
//         this.scopedSocket.on('device.removeGroupDevices', this.removeGroupDevicesListener.bind(this));
//         this.scopedSocket.on('device.updateGroupDevice', this.updateGroupDeviceListener.bind(this));
//     }

//     // Check this====
//     // ngOnDestroy(): void {
//     //   clearTimeout(this.digestTimer);
//     // }

//     add(device: any): void {
//         this.addListener({
//             important: true,
//             data: device
//         });
//     }

//     private addListener(event: any): void {
//         const device = this.get(event.data);
//         if (device) {
//             this.modify(device, event.data);
//             this.notify(event);
//         } else {
//             if (this.options.filter(event.data)) {
//                 this.insert(event.data);
//                 this.notify(event);
//             }
//         }
//     }

//     private changeListener(event: any): void {
//         const device = this.get(event.data);
//         if (device) {
//             this.modify(device, event.data);
//             if (!this.options.filter(device)) {
//                 this.remove(device);
//             }
//             this.notify(event);
//         }
//     }

//     private addGroupDevicesListener(event: any): Promise<any> {
//         return Promise.all(
//             event.devices.map((serial: string) => this.deviceService.load(serial))
//         )
//             .then((_devices: any[]) => {
//                 _devices.forEach((device: any) => {
//                     if (device && typeof this.devicesBySerial[device.serial] === 'undefined') {
//                         this.insert(device);
//                         this.notify(event);
//                     }
//                 });
//             });
//     }

//     private removeGroupDevicesListener(event: any): void {
//         event.devices.forEach((serial: string) => {
//             if (typeof this.devicesBySerial[serial] !== 'undefined') {
//                 this.remove(this.devices[this.devicesBySerial[serial]]);
//                 this.notify(event);
//             }
//         });
//     }

//     private updateGroupDeviceListener(event: any): void {
//         const device = this.get(event.data);
//         if (device) {
//             this.modify(device, event.data);
//             this.notify(event);
//         }
//     }

//     private insert(data: any): void {
//         this.devicesBySerial[data.serial] = this.devices.push(data) - 1;
//         this.sync(data);

//         let filterData = new emitData();
//         filterData.type = 'add';
//         filterData.data = data;

//         this.emit(filterData);
//     }

//     private modify(data: any, newData: any): void {
//         Object.assign(data, newData);
//         this.sync(data);

//         let filterData = new emitData();
//         filterData.type = 'change';
//         filterData.data = data;

//         this.emit(filterData);
//     }

//     private remove(data: any): void {
//         const index = this.devicesBySerial[data.serial];
//         if (index >= 0) {
//             this.devices.splice(index, 1);
//             delete this.devicesBySerial[data.serial];
//             for (const serial in this.devicesBySerial) {
//                 if (this.devicesBySerial.hasOwnProperty(serial) && this.devicesBySerial[serial] > index) {
//                     this.devicesBySerial[serial]--;
//                 }
//             }
//             this.sync(data);

//             let filterData = new emitData();
//             filterData.type = 'remove';
//             filterData.data = data;

//             this.emit(filterData);
//         }
//     }

//     sync(data: any) {
//         // usable IF device is physically present AND device is online AND
//         // preparations are ready AND the device has no owner or we are the
//         // owner
//         data.usable = data.present && data.status === 3 && data.ready &&
//             (!data.owner || data.using)

//         // Make sure we don't mistakenly think we still have the device
//         if (!data.usable || !data.owner) {
//             data.using = false
//         }

//         this.enhanceDeviceService.enhance(data);
//     }

//     private get(data: any): any {
//         return this.devices[this.devicesBySerial[data.serial]];
//     }

//     private notify(event: any): void {
//         if (!this.options.digest) {
//             return;
//         }

//         if (event.important) {
//             window.requestAnimationFrame(this.digest.bind(this));
//         } else {
//             if (!this.digestTimer) {
//                 const delta = Date.now() - this.lastDigest;
//                 if (delta > 1000) {
//                     this.digest();
//                 } else {
//                     this.digestTimer = setTimeout(this.digest.bind(this), delta);
//                 }
//             }
//         }
//     }

//     private digest(): void {
//         if (!this.$scope.$$phase) {
//             this.$scope.$digest();
//         }
//         this.lastDigest = Date.now();
//         this.digestTimer = null;
//     }

// }

